// extracted by mini-css-extract-plugin
export default {"phoneNumber":"ErrorPane_phoneNumber__SfRlO"};